import { Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { useAuth } from 'react-oidc-context';

const PrivateRoute = ({ element, allowedRoles }) => {
  const user = useSelector((state) => state.auth.user);
  const roles = useSelector((state) => state.auth.roles);
  const auth = useAuth();

  if(auth.isLoading) {
    return <>Authenticating...</>
  }

  if (!auth.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if(!user || !roles || roles.length == 0) {
    return <>Loading user info...</>
  }

  if (allowedRoles && !roles.some(role => allowedRoles.includes(role))) {
    return <Navigate to="/unauthorized" replace />;
  }

  return element;
};

export default PrivateRoute;
